import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { motion } from "framer-motion";
import bgImage from "../../assets/HeroImages/Bg.png";
import forg1 from "../../assets/HeroImages/forg1.png";
import forg2 from "../../assets/HeroImages/forg2.png";
import forg3 from "../../assets/HeroImages/forg3.png";
import Krishnakant from "../../assets/HeroImages/Krishnakant_Vishwakarma.png";
import Nirala from "../../assets/HeroImages/Nirala_Kumar.png";
import Rohit from "../../assets/HeroImages/Rohit_chavan.png";
import Sneha from "../../assets/HeroImages/Sneha_Khandelwal.png";
import Ujjwal from "../../assets/HeroImages/Ujjwal_Bhardwaj.png";

const images = [Sneha, Nirala, Rohit, Ujjwal];

const texts = [
  { name: "Sneha Khandelwal", designation: "Software engineer" },
  // { name: "Krishnakant", designation: "Data Engineer" },
  { name: "Nirala Kumar", designation: "Software Engineer" },
  { name: "Rohit Chavan", designation: "Full Stack Developer" },
  { name: "Ujjwal Bhardwaj", designation: "Data Engineer" },
];

const HeroSection = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 6000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex flex-wrap justify-between items-start gap-0 px-4 sm:px-10 md:px-24 py-10 sm:py-20 lg:py-28 min-h-[700px] ">
      {/* Hero Left Section */}
      <div className="flex flex-col items-center text-center gap-5 w-full sm:w-full md:w-5/12">
        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#4130e0]">
          Join us to connect with industry experts today
        </h1>
        <div className="text-lg sm:text-xl md:text-xl leading-7 text-gray font-normal text-[#345493]">
          Elevate your expertise by learning from industry leaders. Start your
          journey towards success today.
        </div>
        <div className="flex gap-4 mt-2 flex-wrap justify-center">
          <NavLink
            to={"/about"}
            className="secondary-btn font-bold text-xl"
            style={{ height: "60px", width: "250px" }}
          >
            Learn More <ArrowForwardIcon />
          </NavLink>
          <NavLink
            to={"/mentors-list"}
            className="primary-btn font-bold text-xl"
            style={{ height: "60px", width: "250px" }}
          >
            Book Session
          </NavLink>
        </div>
      </div>

      {/* Hero Right Section */}
      <div className="relative w-full sm:w-full md:w-2/5 mt-10 md:mt-0">
        <div className="relative w-full h-[400px] overflow-hidden">
          {/* Background Image Animation */}
          <motion.div
            className="absolute inset-0 bg-cover bg-center"
            style={{
              // backgroundImage: `url(${bgImage})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
            initial={{ x: "-100%" }} // Start from the left
            animate={{
              x: ["-100%", "0%", "100%"],
            }}
            transition={{
              duration: 6,
              ease: "easeInOut",
              times: [0, 0.5, 1],
              repeat: Infinity,
              repeatDelay: 0,
            }}
          />

          {/* Foreground Image Animation */}
          <motion.div
            className="absolute inset-0 flex justify-center items-end"
            initial={{ x: "100%" }}
            animate={{
              x: ["100%", "0%", "-100%"],
            }}
            transition={{
              duration: 6,
              ease: "easeInOut",
              times: [0, 0.5, 1],
              repeat: Infinity, // Repeat infinitely
              repeatDelay: 0,
            }}
          >
            <img
              className="w-[300px] object-contain rounded-lg"
              src={images[index]}
              alt="Foreground"
              height="300px"
            />
          </motion.div>
        </div>

        {/* Name and Designation Container */}
        <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 bg-gradient-to-r from-[#2563EB] to-[#1E3A8A] text-white px-2 py-2 rounded-lg w-[300px] shadow-md">
          <h3 className="text-center text-2xl font-bold">
            {texts[index].name}
          </h3>
          <p className="text-center text-lg">{texts[index].designation}</p>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;